export function mapFromCollectionByKey<T>(collection: T[], key: string): Map<string, T> {
  return collection.reduce((acc: Map<string, any>, record) => {
    acc.set(record[key], record);

    return acc;
  }, new Map());
}
